import { Component, OnInit, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ConfigService } from './services/config.service';
import { HomeService } from './services/home.service';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'project';
  private subscriptions: Subscription[] = [];

  constructor(
    private meta: Meta, 
    private configService: ConfigService, 
    private homeService: HomeService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.setMetaTags();
    this.loadConfig();
    this.setupRouteEvents();
    
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Set meta tags for SEO
   */
  private setMetaTags(): void {
    this.meta.addTag({ 
      name: 'description', 
      content: 'Goldsikka Limited is part of a diversified three decades old Aztar Group. Est. in 1990, which specializes in Print Media, Tech Application, Insurance Broking, Data Analytics, Ecommerce, Non Tangible Asset Management, Property Underwriting, Corporate Law Advisory and Activations' 
    });

    this.meta.addTag({ 
      name: 'keywords', 
      content: 'Gold, Silver, Bullion, Investment, Gold Bharat, Precious Metals' 
    });

    this.meta.addTag({ 
      name: 'author', 
      content: 'Gold Bharat' 
    });
  }

  /**
   * Load configuration from server
   */
  private loadConfig(): void {
    const configSub = this.configService.loadConfig().subscribe({
      next: (config) => {
        if (config?.company?.globalBackGroundColor) {
          this.applyGlobalStyles(config.company.globalBackGroundColor);
        }
      },
      error: (error) => {
        console.error('Error loading config:', error);
      }
    });
    this.subscriptions.push(configSub);
  }

  /**
   * Setup route events to check user status only on specific routes
   */
  private setupRouteEvents(): void {
    // Check user status only after navigation ends and only on protected routes
    const routerSub = this.router.events
      .pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
      )
    .subscribe((event: NavigationEnd) => {
  const scrollContainer = document.querySelector('.your-scroll-container-class'); // exact class పెట్టండి
  if (scrollContainer) {
    scrollContainer.scrollTo(0, 0);
  }
  window.scrollTo(0, 0); // fallback

  if (this.isProtectedRoute(event.urlAfterRedirects)) {
    this.checkUserStatus();
  }
});
    
    this.subscriptions.push(routerSub);
    
    // Also check on initial load if we're on a protected route
    // if (this.isProtectedRoute(this.router.url)) {
    //   this.checkUserStatus();
    // }
  }

  /**
   * Check if route requires authentication
   */
  private isProtectedRoute(url: string): boolean {
    const protectedRoutes = [
      '/dashboard',
      '/profile',
      '/orders',
      '/wallet',
      '/settings',
      '/mobile/mobileview',
      '/mobile'
    ];
    
    return protectedRoutes.some(route => url.includes(route));
  }

  /**
   * Check user status only if authenticated
   */
  private checkUserStatus(): void {
    // First check if user is authenticated
    if (!this.homeService.isAuthenticated()) {
      console.log('User not authenticated, skipping status check');
      return;
    }

    const statusSub = this.homeService.checkUserStatus().subscribe({
      next: (response) => {
        console.log('User status is active:', response);
        
        // If token is refreshed in response, it's handled in the service
        if (response?.token) {
          console.log('Token refreshed');
        }
      },
      error: (error) => {
        // Error is already handled in the service (clearSession called)
        console.log('User status check failed:', error.message);
        
        // Don't show error toast here as it might be annoying on every page
        // The service will handle redirect to login if needed
      }
    });
    
    this.subscriptions.push(statusSub);
  }

  /**
   * Apply global styles
   */
  applyGlobalStyles(globalBackGroundColor: string): void {
    if (globalBackGroundColor) {
      document.body.style.backgroundColor = globalBackGroundColor;
    }
  }
}